export const WatchIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00041 14.6663C11.6823 14.6663 14.6671 11.6816 14.6671 7.99967C14.6671 4.31778 11.6823 1.33301 8.00041 1.33301C4.31851 1.33301 1.33374 4.31778 1.33374 7.99967C1.33374 11.6816 4.31851 14.6663 8.00041 14.6663Z"
      stroke="#262626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 4V8L10.6667 9.33333"
      stroke="#262626"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
